"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateScopedCSSVar = exports.validateCustomPropertyName = exports.validateAtProperty = exports.atPropertyValidationWarnings = void 0;
const string_1 = require("../helpers/string");
const UNIVERSAL_SYNTAX_DEFINITION = '*';
const AT_PROPERTY_DISCRIPTOR_LIST = ['initial-value', 'syntax', 'inherits'];
exports.atPropertyValidationWarnings = {
    MISSING_REQUIRED_DESCRIPTOR(descriptorName) {
        return `@property rules require a "${descriptorName}" descriptor`;
    },
    MISSING_REQUIRED_INITIAL_VALUE_DESCRIPTOR() {
        return '@property "initial-value" descriptor is optional only if the "syntax" is the universal syntax definition, otherwise the descriptor is required';
    },
    INVALID_DESCRIPTOR_TYPE(descriptorType) {
        return `@property does not support descriptor of type "${descriptorType}"`;
    },
    INVALID_DESCRIPTOR_NAME(descriptorName) {
        return `@property does not support descriptor named "${descriptorName}"`;
    },
};
function validateAtProperty(atRule, diagnostics) {
    var _a;
    const name = atRule.params;
    const atPropertyValues = new Map();
    if (!((_a = atRule.nodes) === null || _a === void 0 ? void 0 : _a.length)) {
        return {
            valid: true,
        };
    }
    for (const node of atRule.nodes) {
        if (node.type !== 'decl') {
            if (node.type === 'atrule' || node.type === 'rule') {
                diagnostics.warn(node, exports.atPropertyValidationWarnings.INVALID_DESCRIPTOR_TYPE(node.type), {
                    word: 'params' in node ? node.params : node.selector,
                });
            }
            continue;
        }
        if (!AT_PROPERTY_DISCRIPTOR_LIST.includes(node.prop)) {
            diagnostics.warn(node, exports.atPropertyValidationWarnings.INVALID_DESCRIPTOR_NAME(node.prop), {
                word: node.prop,
            });
            continue;
        }
        atPropertyValues.set(node.prop, (0, string_1.stripQuotation)(node.value));
    }
    if (!atPropertyValues.has('syntax')) {
        diagnostics.warn(atRule, exports.atPropertyValidationWarnings.MISSING_REQUIRED_DESCRIPTOR('syntax'), { word: name });
        return {
            valid: false,
        };
    }
    if (!atPropertyValues.has('inherits')) {
        diagnostics.warn(atRule, exports.atPropertyValidationWarnings.MISSING_REQUIRED_DESCRIPTOR('inherits'), { word: name });
        return {
            valid: false,
        };
    }
    if (!atPropertyValues.has('initial-value') &&
        atPropertyValues.get('syntax') !== UNIVERSAL_SYNTAX_DEFINITION) {
        diagnostics.warn(atRule, exports.atPropertyValidationWarnings.MISSING_REQUIRED_INITIAL_VALUE_DESCRIPTOR(), { word: name });
        return {
            valid: false,
        };
    }
    return {
        valid: true,
    };
}
exports.validateAtProperty = validateAtProperty;
function validateCustomPropertyName(value) {
    return value.startsWith('--');
}
exports.validateCustomPropertyName = validateCustomPropertyName;
function generateScopedCSSVar(namespace, varName) {
    return `--${namespace}-${varName}`;
}
exports.generateScopedCSSVar = generateScopedCSSVar;
//# sourceMappingURL=css-custom-property.js.map